module.exports = __webpack_public_path__ + "static/media/draft.e8cc4789.svg";